export const appUrl = (path = '') => {
  return `${process.env.APP_URL}${path}`
}
